export default "<div *ngIf=\"errorMessage !== null\" class=\"errorMessage\">{{errorMessage}}</div>";